import React from 'react'
import rccarimg from '../assests/rccar.jpeg'
import robotarm from '../assests/robotarm.jpeg'
import heatexchanger from '../assests/heat_exchanger.jpeg'
import spline from '../assests/utfr.jpeg'
import { Link } from 'react-router-dom';
import bez from '../assests/robosoccer/robot_jerry.jpeg'

const Portfolio = () => {
  return (
    <div name='portfolio' className='w-full min-h-screen text-blue-light bg-base pt-[120px]'>
      <div className='max-w-[900px] mx-auto p-4 flex flex-col justify-center w-full h-full'>
        <div className='pb-8'>
          <p className='text-4xl font-bold inline border-b-4 text-blue-dark border-blue-dark'>Portfolio</p>
          <p className='py-6 text-gray'>{'// Check out some of my recent projects'}</p>
        </div>

        {/* Container */}
        <div className='flex flex-col gap-8'>

          {/* RoboSoccer Card */}
          <div className='flex flex-col md:flex-row items-center shadow-lg shadow-blue-dark rounded-md overflow-hidden'>
            <div
              style={{ backgroundImage: `url(${bez})` }}
              className='w-full md:w-1/2 h-80 bg-cover bg-center'
            />
            <div className='p-4 flex flex-col justify-center w-full md:w-1/2 text-center md:text-left'>
              <span className='text-2xl font-bold text-blue-dark tracking-wider'>RoboSoccer (Humanoid Robot)</span>
              <p className='pt-4 text-gray'>Currently working to upgrade the teams object detection from YOLOv5 to v8 and segmentation for fieldlines.</p>
              <div className='pt-4 flex justify-center md:justify-start'>
                <Link to='/projects/robosoccer'>
                  <button className='rounded-lg px-4 py-3 m-2 bg-white text-blue-dark font-bold text-lg'>Blog</button>
                </Link>
                <Link to='/projects/robosoccer/map'>
                  <button className='rounded-lg px-4 py-3 m-2 bg-white text-blue-dark font-bold text-lg'>Map</button>
                </Link>
                {/* <a href='/'>
                  <button className='rounded-lg px-4 py-3 m-2 bg-white text-blue-dark font-bold text-lg'>GitHub</button>
                </a> */}
              </div>
            </div>
          </div>

          {/* Card - RC Car*/}
          <div className='flex flex-col md:flex-row items-center shadow-lg shadow-blue-dark rounded-md overflow-hidden'>
            <div
              style={{ backgroundImage: `url(${rccarimg})` }}
              className='w-full md:w-1/2 h-80 bg-cover bg-center'
            />
            <div className='p-4 flex flex-col justify-center w-full md:w-1/2 text-center md:text-left'>
              <span className='text-2xl font-bold text-blue-dark tracking-wider'>Autonomous RC Car</span>
              <p className='pt-4 text-gray'>Tarmo5 (a 3D printable RC car) made autonomous using ROS2. Set-up a sim environment, used v4l2 on a Jetson to publish camera data, OpenCV for video processing with proportional control, MircoROS to control velocity and steering using an ESP32.</p>
              <div className='pt-4 flex justify-center md:justify-start'>
                <Link to='/projects/autonomousrccar'>
                    <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-blue-dark font-bold text-lg'>Blog</button>
                </Link>
                <a href='https://github.com/AKP-ANT/robot_ws'>
                  <button className='rounded-lg px-4 py-3 m-2 bg-white text-blue-dark font-bold text-lg'>GitHub</button>
                </a>
              </div>
            </div>
          </div>

          {/* Robot Arm Card */}
          <div className='flex flex-col md:flex-row items-center shadow-lg shadow-blue-dark rounded-md overflow-hidden'>
            <div
              style={{ backgroundImage: `url(${robotarm})` }}
              className='w-full md:w-1/2 h-80 bg-cover bg-center'
            />
            <div className='p-4 flex flex-col justify-center w-full md:w-1/2 text-center md:text-left'>
              <span className='text-2xl font-bold text-blue-dark tracking-wider'>Robotic Arm</span>
              <p className='pt-4 text-gray'>Drawing ideas from Automate Show 2024, created a 3-DoF robotic arm in Pybullet using URDF description, wrote inverse kinematics for position targets using trignometry.</p>
              <div className='pt-4 flex justify-center md:justify-start'>
                <Link to='/projects/robotarm'>
                  <button className='rounded-lg px-4 py-3 m-2 bg-white text-blue-dark font-bold text-lg'>Blog</button>
                </Link>
                {/* <a href='/'>
                  <button className='rounded-lg px-4 py-3 m-2 bg-white text-blue-dark font-bold text-lg'>GitHub</button>
                </a> */}
              </div>
            </div>
          </div>

          {/* Praxis Card */}
          <div className='flex flex-col md:flex-row items-center shadow-lg shadow-blue-dark rounded-md overflow-hidden'>
            <div
              style={{ backgroundImage: `url(${heatexchanger})` }}
              className='w-full md:w-1/2 h-80 bg-cover bg-center'
            />
            <div className='p-4 flex flex-col justify-center w-full md:w-1/2 text-center md:text-left'>
              <span className='text-2xl font-bold text-blue-dark tracking-wider'>ESC204 - Course Project</span>
              <p className='pt-4 text-gray'>In a team of four, created a prototype for appartment cooling using deep water cooling. I implemented bang-bang for temperature control using an Arduino Uno and relays to control a pump and fan.</p>
              <div className='pt-4 flex justify-center md:justify-start'>
                <Link to='/projects/praxis'>
                  <button className='rounded-lg px-4 py-3 m-2 bg-white text-blue-dark font-bold text-lg'>Blog</button>
                </Link>
                {/* <a href='/'>
                  <button className='rounded-lg px-4 py-3 m-2 bg-white text-blue-dark font-bold text-lg'>GitHub</button>
                </a> */}
              </div>
            </div>
          </div>

          {/* UTFR Card */}
          <div className='flex flex-col md:flex-row items-center shadow-lg shadow-blue-dark rounded-md overflow-hidden'>
            <div
              style={{ backgroundImage: `url(${spline})` }}
              className='w-full md:w-1/2 h-64 bg-cover bg-center'
            />
            <div className='p-4 flex flex-col justify-center w-full md:w-1/2 text-center md:text-left'>
              <span className='text-2xl font-bold text-blue-dark tracking-wider'>University of Toronto - Formula Racing (Driverless)</span>
              <p className='pt-4 text-gray'>Used teammates midpoints algorithm to draw an optimum path for the race car using splines.</p>
              <div className='pt-4 flex justify-center md:justify-start'>
                <Link to='/projects/splineinterpolation'>
                  <button className='rounded-lg px-4 py-3 m-2 bg-white text-blue-dark font-bold text-lg'>Blog</button>
                </Link>
                {/* <a href='/'>
                  <button className='rounded-lg px-4 py-3 m-2 bg-white text-blue-dark font-bold text-lg'>GitHub</button>
                </a> */}
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default Portfolio;


// const Portfolio = () => {
//   return (
//     <div name='portfolio' className='w-full md:h-screen  text-blue-light bg-base'>
//         <div className='max-w-[900px] mx-auto p-4 flex flex-col justify-center w-full h-full'>
//             <div className='pb-8'>
//                 <p className='text-4xl font-bold inline border-b-4 text-blue-dark border-blue-dark'>Portfolio</p>
//                 <p className='py-6 text-gray'>// Check out some of my recent projects</p>
//             </div>
            
//             {/* container */}
//             <div className='grid sm:grid-cols-2 md:grid-cols-3 gap-4'>

//                 {/* card */}
//                 <div style={{backgroundImage: `url(${catcageimg})`}}
//                 className='shadow-lg shadow-blue-dark group container rounded-md flex justify-center items-center mx-auto content-div'>
                    
//                     {/* hover effect */}
//                     <div className='opacity-0 group-hover:opacity-100'>
//                         <span className='text-2xl font-bold text-blue-dark tracking-wider'>
//                             Praxis Cat Cage
//                         </span>
//                         <div className='pt-8 text-center'>
//                             <a href='/'>
//                                 <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-base font-bold text-lg bg-blue-dark'>Blog</button>
//                             </a>
//                             <a href='/'>
//                                 <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-base font-bold text-lg bg-blue-dark'>GitHub</button>
//                             </a>
//                         </div>
//                     </div>
//                 </div>

//                 {/* card */}
//                 <div style={{backgroundImage: `url(${printerimg})`}}
//                 className='shadow-lg shadow-blue-dark group container rounded-md flex justify-center items-center mx-auto content-div'>
                    
//                     {/* hover effect */}
//                     <div className='opacity-0 group-hover:opacity-100'>
//                         <span className='text-2xl font-bold text-blue-dark tracking-wider'>
//                             3D Printer
//                         </span>
//                         <div className='pt-8 text-center'>
//                             <a href='/'>
//                                 <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-blue-dark font-bold text-lg'>Blog</button>
//                             </a>
//                             <a href='/'>
//                                 <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-blue-dark font-bold text-lg'>GitHub</button>
//                             </a>
//                         </div>
//                     </div>
//                 </div>

//             </div>
//         </div>
//     </div>
//   )
// }